import './css/spinner.css'
const Spinner = () => {
  return (
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}

export default Spinner
